import React, { useEffect, useState, Children } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, SparklesIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FoundationalGiftPopup() {
  const [isEs, setIsEs] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const dismissed = sessionStorage.getItem('haa-gift-popup-dismissed');
    if (dismissed) return;
    // Show after a brief delay so the page has time to render
    const timer = setTimeout(() => setIsOpen(true), 800);
    return () => clearTimeout(timer);
  }, []);
  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('haa-gift-popup-dismissed', '1');
  };
  const handleReadMore = () => {
    handleClose();
    setTimeout(() => {
      const el = document.getElementById('news');
      if (el) {
        const navbarHeight = 88;
        const pos = el.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: pos - navbarHeight,
          behavior: 'smooth'
        });
      }
    }, 300);
  };
  return <AnimatePresence data-id="element-2419" data-mp="1h3u6f1rh9cdf">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={handleClose} data-id="element-2420" data-mp="1h6zv4fw72c8m">
          <motion.div initial={{
        opacity: 0,
        scale: 0.92,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.92,
        y: 20
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-2421" data-mp="jheqw5im2osi">
            {/* Image */}
            <div className="relative w-full h-56 sm:h-64 overflow-hidden" data-id="element-2422" data-mp="27g7b0ksunvz7">
              <img src="https://cdn.magicpatterns.com/uploads/inTd5HUnCqnqHAPt3WDRnZ/IMG_9004.jpg" alt={isEs ? 'Homenajeadas e invitados en la celebración Voces de Impacto en Nueva Orleans' : 'Honorees and guests at the Voices of Impact celebration in New Orleans'} className="w-full h-full object-cover" style={{
            objectPosition: 'center 35%'
          }} data-id="element-2423" data-mp="23e2lny9fplid" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-2424" data-mp="3iv4cwva4ufnz" />
              <button onClick={handleClose} className="absolute top-3 right-3 p-1.5 rounded-full bg-black/40 hover:bg-black/60 text-white transition-colors" aria-label="Close" data-id="element-2425" data-mp="3e21gmfdz0s43">
                <XIcon className="w-4 h-4" data-id="element-2426" data-mp="19lwltju9f8fw" />
              </button>
              {/* Badge */}
              <div className="absolute bottom-4 left-4 right-4" data-id="element-2427" data-mp="1ekq1nix0rbj8">
                <div className="inline-flex items-center gap-1.5 bg-haa-blue text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider shadow-lg" data-id="element-2428" data-mp="1em167kyagnbe">
                  <SparklesIcon className="w-3.5 h-3.5" data-id="element-2429" data-mp="1ohvscq1q10ix" />
                  {isEs ? 'Voces de Impacto 2026' : 'Voices of Impact 2026'}
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-5 sm:p-6" data-id="element-2430" data-mp="1xapnlwxkcaif">
              <h3 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider leading-tight mb-2" data-id="element-2431" data-mp="22ac209p4nwst">
                {isEs ? '¡Voces de Impacto en Nueva Orleans fue un Éxito Total!' : 'Voices of Impact in New Orleans Was a Total Success!'}
              </h3>
              <p className="font-nunito text-gray-600 text-sm leading-relaxed mb-4" data-id="element-2432" data-mp="1onv1q672ee98">
                {isEs ? 'Este fin de semana pasado, la Asociación Hondureño-Americana celebró su recepción inaugural Voces de Impacto en Nueva Orleans durante la Convención de la Asociación Nacional de Periodistas Hispanos — una velada inolvidable que honró a destacadas periodistas y líderes de medios hondureño-americanas y reunió a líderes cívicos, empresariales y comunitarios de todo el país. ¡Gracias a todos los que hicieron posible este momento histórico!' : 'This past weekend, the Honduran-American Association celebrated its inaugural Voices of Impact reception in New Orleans during the National Association of Hispanic Journalists Convention — an unforgettable evening honoring leading Honduran-American journalists and media leaders, and bringing together civic, business, and community leaders from across the country. Thank you to everyone who made this historic moment possible!'}
              </p>

              <div className="flex flex-col gap-2" data-id="element-2433" data-mp="33lh7oj24mmpu">
                <button onClick={handleReadMore} className="w-full inline-flex items-center justify-center gap-1.5 bg-haa-blue hover:bg-haa-midblue text-white font-nunito font-bold text-sm px-5 py-2.5 rounded-xl transition-colors" data-id="element-2434" data-mp="2pkwpnp41cuxe">
                  {isEs ? 'Ver la Historia' : 'See the Story'}
                  <ArrowRightIcon className="w-4 h-4" data-id="element-2435" data-mp="3m9ul79jm0wvm" />
                </button>
                <button onClick={handleClose} className="w-full inline-flex items-center justify-center gap-1.5 bg-red-600 hover:bg-red-700 text-white font-nunito font-bold text-sm px-5 py-2.5 rounded-xl transition-colors" data-id="element-2436" data-mp="38kkcc2e72qxa">
                  {isEs ? 'Cerrar Anuncio' : 'Close Announcement'}
                </button>
                <button onClick={() => setIsEs(!isEs)} className="w-full inline-flex items-center justify-center gap-1.5 text-haa-navy/60 hover:text-haa-navy font-nunito font-semibold text-xs px-4 py-1.5 rounded-lg transition-colors" data-id="element-2437" data-mp="is9fc7ofsna8">
                  {isEs ? 'Read in English' : 'Leer en Español'}
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}